import React, { useState,  useEffect } from "react";
import TableHeader from "../../common/table/TableHeader";
import TableSkeleton from "../../common/table/TableSkeleton";
import handleError from "../../../constant/handleError";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import axiosInstance from "../../../utils/AxiosInstance";
import useShowAlert from "../../../utils/AlertUtiles";
import uRLs from "../../../utils/baseUtils";
import DateConverter from "@heartinz/date_and_time_processor";
import { capitalizeFirstLetter } from "../../../utils/helper";
import ReactPaginate from "react-paginate";
import PartnerView from "./PartnerView";

const ApprovalBadge = ({ status }) => {
  let className = "app-badge  ";
 let displayText = status; 
  if (status === "Approved") {
    className += "bg-label-spring";
  } else if (status === "Rejected") {
    className += "bg-danger";
  } else if (status === "Pending") {
    className += "bg-warning ";
  } 
  else if (status === "GANGLEADER") {
    className += "bg-label-navy ";
     displayText = "Captain";
  } 
    else if (status === "FIELDOFFICER") {
    className += "bg-label-wave ";
    displayText = "Field Officer";
  }else {
    className += "bg-light text-dark";
  }

  return <span className={className}>{displayText}</span>;
};

function PartnerManagement() {

  const [activeTab, setActiveTab] = useState("All Partners");
  const [partnersData, setPartnersData] = useState([]);
  const [roleSelections, setRoleSelections] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [loading, setLoading] = useState({
      list: false,
      update:null
    });

  const showAlert = useShowAlert();

  const handleRoleChange = (partnerId, role) => {
        setRoleSelections(prev => ({
            ...prev,
            [partnerId]: role
        }));
    };

    const fetchPartners = async (page = 0, tab = activeTab) => {
        setLoading((prev) => ({ ...prev, list: true }));
        checkNetworkStatus();

    try {
      let endpoint = "";
      if (tab === "Approved") endpoint = `partner/admin/approved?pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
      else if (tab === "Not Approved") endpoint = `partner/admin/unapproved?pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
      else endpoint = `partner/admin/?pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
       const response = await axiosInstance.get(endpoint);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {
          const updatedResults = response.data.results.map((p) => ({
          ...p,          
          isApproved: p.isApproved ?? false,
        }));
        setPartnersData(updatedResults);
      }
      else{
        setPartnersData([])
      }
      if (response?.data?.results?.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response?.data.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      setPartnersData([]);
      setTotalPages(0);
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, list: false }));
    }
  };
  
  const approvePartner = async (partnerId, role) => {
  if (!role) {
    showAlert("warning","Please select a role before approving.");
    return;
  }
       setLoading((prev) => ({ ...prev, update: partnerId  }));
        checkNetworkStatus();

    try {  
       const data = { role: role };   
       const response = await axiosInstance.patch(`partner/admin/${partnerId}`,data);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results
      ) {
            const updatedPartner = response.data.results;           
            setPartnersData((prevData) => {               
            
                if (activeTab === "Not Approved") {
                  setTotalItems(prev => prev - 1);
                   return prevData.filter(p => p._id !== partnerId);
                } else {                    
                    return prevData.map((p) =>
                        p._id === partnerId
                            ? {
                                ...p,  
                                isApproved: updatedPartner.isApproved ?? true,
                                role: updatedPartner.role,
                            }
                            : p
                    );
                }
            });            
         setSelectedPartner((prev) =>
            prev && prev._id === partnerId
              ? { ...prev, isApproved: updatedPartner.isApproved, role: updatedPartner.role }
              : prev
          );
        setRoleSelections((prev) => {
        const newState = { ...prev };
        delete newState[partnerId];
        return newState;
      });

      }
      showAlert("success",response?.data?.message)
    } catch (error) {     
      handleError(error, showAlert);
      return false;
    } 
    finally{
       setLoading((prev) => ({ ...prev, update: null  }));
    }
  };

  const handleViewPartner = (partner) => {
      setSelectedPartner(partner);   
      if (!partner.isApproved && !roleSelections[partner._id]) {
          handleRoleChange(partner._id, ''); 
      }
      setIsModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPartner(null);
}

 useEffect(() => {
    fetchPartners (currentPage,activeTab);
  }, [currentPage,activeTab]);
  
 const allHeaders = [
      "S.No",
      "Date",
      "Partner Name",
      "Phone",
      "Role",
      "Status",    
    ];
const headers = activeTab === "All Partners"
  ? allHeaders
  : allHeaders.filter(header => header !== "Status");

  const tabs = ["All Partners", "Approved", "Not Approved"];

  return (
    <>
      <div className=" pe-3">
        <div class="breadcrumb-title pe-3 mb-2">Partner List</div>
      </div>

      <div className="mb-3">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() =>{if (activeTab !== tab) {
                    setCurrentPage(0); 
                } setActiveTab(tab)}}
            className=" me-1 cursor-poInter"
            style={{
              padding: "10px 15px",
              border: "none",
              fontWeight: activeTab === tab ? "bold" : "normal",
              borderBottom:
                activeTab === tab ? "2px solid blue" : "2px solid transparent",
              backgroundColor: "transparent",
            }}
          >
            {tab}
            {/* <span className="ms-1 text-muted">
              (
              {totalItems || 0}
              )
            </span> */}
          </button>
        ))}
      </div>
      <div className="col-col-12 ">
        <div className="card mb-0">
          <div className="card-body p-0">
            <table className="table align-middle table-hover mb-0 cursor-pointer ">
              <TableHeader headers={headers} />

              <tbody>
                {loading.list ? (
                  <TableSkeleton
                    rows={5}
                   columns={activeTab === "All Partners" ?[300, 200, 200, 100, 100, 100,  ]:[300, 200, 200, 200,  ] }
                  />
                ) : Array.isArray(partnersData) && partnersData.length > 0 ? (
                  partnersData.map((partner, index) => (
                    <tr key={partner._id || index} onClick={() => handleViewPartner(partner)}>
                      <td className="text-center">{totalItems - (currentPage * uRLs.PER_PAGE + index)}</td>
                      <td className="text-center">  { DateConverter.ISOToDisplayFormat(
                          DateConverter.convertToTimeZone(partner?.createdAt, uRLs.TIMEZONE)
                        ).date}</td>
                      <td className="text-center">
                        {capitalizeFirstLetter(partner.name)||"-"}
                      </td>
                      <td className="text-center">
                        <p className="mb-0 text-center fw-bold">
                         {partner?.mobileNumber}
                        </p></td>
                                         
                        <td className="text-center">   
                          {partner?.role ?(
                          <ApprovalBadge 
                              status={partner?.role }                            
                            />
                          ):(
                            "-"
                          )}                       
                           {/* <>                    
                              {partner.role ? (              
                          <ApprovalBadge 
                            status={partner.role}                            
                          />):(<>
                             <select 
                              className="form-select form-select-sm d-inline-block "
                              style={{ width: '200px' }} 
                             value={roleSelections[partner._id] || ''}
                             onChange={(e) => handleRoleChange(partner._id, e.target.value)}
                              
                          >
                              <option value="">-- Select Role --</option>
                              <option value="FIELDOFFICER">Field Officer</option>
                              <option value="GANGLEADER">Captain</option>
                          </select>
                       </>   )}</> */}
                        
                        </td>
                          {activeTab === "All Partners" && (
                          <td className="text-center">
                            {/* {!partner?.isApproved ? (
                              loading.update === partner._id ? (
                              <button
                                  className="btn btn-primary pb-0 text-right"
                                  disabled            >
                                
                                  <CircularProgress size={22} className="text-white" />
                              </button>
                                                
                          ) : (
                            <button 
                               className="btn btn-sm btn-primary font-12"
                            disabled={!roleSelections[partner._id]} 
                             onClick={() => approvePartner(partner._id, roleSelections[partner._id])}
                             >
                             Approve
                            </button>
                          )
                            ):(
                  */}
                  {!partner?.isApproved ? (
                     <span className="app-badge bg-label-warning"  >
                         Pending</span>
                  ):(
                        <span className="app-badge bg-label-spring"  >
                         Approved</span>
                        )}
                         </td> 
                          )}
                                         
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center p-2 text-muted">
                      <span className="text-muted">
                        No partners found in this list.
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
            {totalPages > 0 &&  (
                        <div className="d-flex justify-content-center mt-3">
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setLoading((prev) => ({ ...prev, list: true }));
                              setCurrentPage(selected);
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        </div>
                      )}
            {isModalOpen && (
               <PartnerView                   
                  onClose={handleCloseModal}
                  partner={selectedPartner}
                  roleSelections={roleSelections}
                  handleRoleChange={handleRoleChange}
                  onApprove={approvePartner}
                  loadingUpdate={loading.update}
              />
             )}
        </div>
      </div>
     
    </>
  );
}

export default PartnerManagement;
